import { render } from "./RigaProdotto.vue?vue&type=template&id=1dc59f54&ts=true"
import script from "./RigaProdotto.vue?vue&type=script&lang=ts"
export * from "./RigaProdotto.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\htdocs\\sputnik\\vue\\verdura-ordini-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__